import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "bg-primary-700 hover:bg-primary-600 rounded shadow-[0_0_4px_0px_rgb(17,24,39,0.25)] p-[6px] border border-transparent mx-1 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-primary-600"
}

import { CheckIcon } from '@heroicons/vue/24/outline';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckButton',
  props: {
    // routeLink: {
    //     type: String,
    //     required: true,
    // },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(_unref(CheckIcon), { class: "w-5 h-5 text-white mx-auto stroke-2" })
  ]))
}
}

})